/**
 * @file Shared React component — components/Layout/DashboardFooter.tsx.
 */

import React from "react";
import "./DashboardFooter.css";

const DashboardFooter: React.FC = () => {
  return (
    <footer className="dashboard-footer">
      Center for Advanced Research in Building Science Energy
    </footer>
  );
};

/** React component — Dashboard Footer. */
export default DashboardFooter;
